import { useI18n } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/SectionHeading";

export const Objectives = () => {
  const { t } = useI18n();
  const o = t.objectives;
  return (
    <section id="objectives" className="scroll-mt-24 bg-background">
      <div className="container-site section-pad py-20 md:py-24">
        <SectionHeading eyebrow={o.eyebrow} title={o.title} description={o.desc} />
        <div className="mt-12 grid gap-x-10 gap-y-2 md:grid-cols-2">
          {o.items.map((obj, i) => (
            <Reveal key={i} delay={i * 0.06} className="group flex items-start gap-5 border-b border-border py-6">
              <span className="font-display text-2xl font-medium text-gold-ink/80 transition-colors group-hover:text-gold">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="pt-1 text-base leading-relaxed text-foreground/90">{obj}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
